import React from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  icons,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@tapresearch/ui/components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Campaign } from '../../../../api';
import useAsset from '../../../hook/useAsset';

interface QuestionSingleWaveSelectProps {
  waves: Campaign[];
  projectIdentifier: string;
}
export const QuestionSingleWaveSelect = ({
  waves,
  projectIdentifier,
}: QuestionSingleWaveSelectProps) => {
  const { constants } = useAsset();

  return (
    <Menu isLazy autoSelect={false}>
      <MenuButton
        as={Button}
        data-testid="question-single-wave-select-trigger"
        variant="ghost"
        fontWeight="semibold"
        colorScheme="blue"
        color="blue.500"
        rightIcon={<Icon icon={icons.fi.ChevronDown} />}
      >
        Select wave
      </MenuButton>
      <MenuList
        data-testid="question-single-wave-select-menu"
        {...{
          py: 2,
          px: 1,
          maxH: '300px',
          minW: '180px',
          overflowY: 'scroll',
        }}
      >
        {waves.map((wave) => {
          if (wave.attributes.status === constants.STATUS_DRAFT) return null;
          return (
            <SingleWaveMenuItem
              key={wave.attributes.identifier}
              wave={wave}
              projectIdentifier={projectIdentifier}
            />
          );
        })}
      </MenuList>
    </Menu>
  );
};

const SingleWaveMenuItem = ({
  wave,
  projectIdentifier,
}: {
  wave: Campaign;
  projectIdentifier: string;
}) => {
  return (
    <MenuItem
      data-testid="single-wave-menu-item"
      {...{
        as: Link,
        to: `/projects/${projectIdentifier}/campaigns/${wave.attributes.identifier}`,
        target: '_blank',
        rel: 'noopener noreferrer',
        rounded: 'md',
        fontSize: 'sm',
        color: 'gray.600',
        mb: 1,
        py: 2,
        transitionProperty: 'common',
        transitionDuration: 'normal',
        _hover: {
          bg: 'blue.100',
        },
      }}
    >
      <Flex
        sx={{ lineHeight: 1 }}
        w="full"
        justify="space-between"
        align="center"
      >
        <Flex>Wave {wave.attributes.wave_number}</Flex>
        <Flex>
          {`${moment(wave.attributes.launch_date).format('M/D')}`}
          <Icon wrapAs={Box} boxSize={4} ml={4} icon={icons.io4.MdOpen} />
        </Flex>
      </Flex>
    </MenuItem>
  );
};
